import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getLabourTaskByOperationEntityIDTaskCategoryID,
    GetBlockImageReportData,
    GetAllOperationEntityByGroupID,
    GetFieldsByCollectionPointID,
    GetBlocksByFieldID,
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == operationEntityID) {
            array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}

async function getLabourTaskByOperationEntityIDTaskCategoryID(estateID, registrationNumber) {
    const response = await CommonGet('/api/EmployeeTask/GetTaskDetailByOperationEntityID', 'operationEntityID=' + estateID + '&registrationNumber=' + registrationNumber);
    return response.data;
}

async function GetFieldsByCollectionPointID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["fieldID"]] = item[1]["fieldName"]
        }
    }
    return divisionArray;
}

async function GetBlocksByFieldID(id) {
    var blockArray = [];
    const response = await CommonGet('/api/Block/GetBlocksByFieldID', 'id=' + id);
    for (let item of Object.entries(response.data)) {
            blockArray[item[1]["blockID"]] = item[1]["blockName"]
    }
    return blockArray;
}

async function GetBlockImageReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        searchDate: data.searchDate,
        fieldID: parseInt(data.fieldID),
        blockID: parseInt(data.blockID),
    };
    console.log('model',model)
    const response = await CommonPost('/api/BlockImageReport/GetBlockImageReportData', null, model);
    console.log('response',response)
    return response.data;
}